import axiosapi from "./axiosAPI";

// Get All EducationLevels
export const getAllEducationLevels = async (
    setEducationLevels,
    setFetcherror,
    options
) => {
    
    
	try{
		const res =await axiosapi.get("/educationlevels");
        setEducationLevels(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch EducationLevels");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch EducationLevels");
		}
		
	}
	
};



// Get One EducationLevel
export const getOneEducationLevel = async (
    pkid,
    setFetcherror,  
    setEducationLevel
    
)=>{
	try{
		const res =await axiosapi.get(`/educationlevels/${pkid}`);
        setEducationLevel(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch EducationLevel");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch EducationLevel");
		}
		
	}
	
};


// Create New EducationLevel
export const createEducationLevel = async (
    e,
    educationLevel,
    setEducationLevel,
    setFetcherror,
    handleAllToasts

) => {

    e.preventDefault();

    if (!educationLevel ) {
        handleAllToasts(2, "No EducationLevel Provided"); 
            return; 
        }

    const PushItem = {
            name: educationLevel,
        };

    try{
        await axiosapi.patch("/educationlevels/",PushItem );
        setEducationLevel("");
        handleAllToasts(1, "EducationLevel Created Successfully");
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New EducationLevel");
            handleAllToasts(2, "Could Not update The EducationLevel");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New EducationLevel");
            handleAllToasts(2, "Could Not update The EducationLevel");
            
        }
        
    }
    
}


// Edit Existing EducationLevel

export const editEducationLevel = async (
    e,
    educationLevelpkid,
    educationLevel,
    setEducationLevel,
    setFetcherror,
    handleAllToasts
              
        ) => {
            e.preventDefault();

            if (!educationLevel) {
                handleAllToasts(2, "No EducationLevel Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:educationLevelpkid,
                    name: educationLevel,
                };

            try{
                await axiosapi.patch("/educationlevels/",PushItem );
                setEducationLevel("");
                handleAllToasts(1, "EducationLevel Updated Successfully");
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update EducationLevel");
                    handleAllToasts(2, "Could Not Update EducationLevel");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update EducationLevel");
                    handleAllToasts(2, "Could Not Update EducationLevel");
                    
                }
                
            }
            
};



// Delete Existing EducationLevel.

export const deleteEducationLevel = async (
    educationLevelpkid,
    seteducationLevels,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/educationlevels/${educationLevelpkid}`);
        let finalData = res.data.message;
        getAllEducationLevels(seteducationLevels, setFetcherror);
        handleAllToasts(1, "EducationLevel Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete EducationLevel");
            handleAllToasts(2,"Error: Could Not Delete EducationLevel");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete EducationLevel");
            handleAllToasts(2,"Error: Could Not Delete EducationLevel");
		}
		
	}
	
};